// extracted by mini-css-extract-plugin
export default {"container":"TermsDetailModal_container__650pP","content":"TermsDetailModal_content__84ARB","footer":"TermsDetailModal_footer__9HBHV"};